<template>
  <v-select
    :label="label"
    :name="name"
    :value="value"
    :error="getError"
    :error-messages="getErrorContents"
    :loading="loading"
    :rules="getRules"
    :items="arrayTipo"
    :info="info"
    :readonly="readonly"
    :disabled="disabled"
    :return-object="isObject"
    :item-text="itemText"
    item-value="id"
    
    @change="$emit('input', $event)"
  >
    <template v-slot:item="{ item }">
        <p class="ed-table-info" >
          {{item[itemText]}}
          <label v-if="item.obs">
            {{item.obs}}
          </label>
        </p>
    </template>
  </v-select>
</template>

<script>
import EdFormMixin from "./mixins/formControl";
import EdInputSelect from "./EdInputSelect";

export default {
  name: "EdInputTipo",
  mixins: [EdFormMixin],
  components: { EdInputSelect },
  props: {
    tipo: {
      type: [String, Number],
      required: true,
      default: null,
    },
    itemText: {
      type: [String, Number],
      required: false,
      default: 'nome',
    },
    isObject: {
      ype: [Boolean],
      required: false,
      default: false,
    },
  },
  data() {
    return {
      arrayTipo: [],
    };
  },
  beforeDestroy() {
    this.arrayTipo = [];
  },
  created() {},
  mounted() {
    this.getTipo();
  },
  computed: {},
  methods: {
    getTipo() {
      if (!this.tipo) return;

      this.$root.$request
        .post("common/tipo", { parent: [this.tipo] })
        .then((result) => {
          if (result.status == 200) {
            this.arrayTipo = result.data[this.tipo];
          }
        });
    },
  },
  watch: {
    tipo() {},
    value() {},
  },
};
</script>


// WEBPACK FOOTER //
// src/components/template/EdInputTipo.vue